module.exports = __webpack_public_path__ + "static/media/特色功能@2x.96c9419e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/特色功能@2x.png
// module id = 1438
// module chunks = 0